// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XNhH","icon":"styles_icon__20ybu"};